import { styled } from "@mui/material/styles";
import { theme } from "styles/themes";

export const HeaderContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  fontSize: "22px",
}));

export const ModalContentContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  fontSize: "14px",
  fontWeight: 500,
  color: theme.colors["queen-blue"],
}));

export const IconContainer = styled("div")(() => ({
  background: theme.colors["pumpkin-light"],
  width: "32px",
  height: "32px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingBottom: "2px",
}));

export const BasicText = styled("div")(() => ({
  fontSize: "16px",
  fontWeight: 500,
  color: theme.colors["queen-blue"],
}));

export const BoldText = styled("div")(() => ({
  fontFamily: "Poppins",
  fontSize: "18px",
  lineHeight: "22px",
  fontWeight: 700,
  color: theme.colors["darkest-blue"],
}));

export const ExistingLeadContainer = styled("div")(() => ({
  background: theme.colors["whale-white"],
  padding: "16px",
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  fontSize: "14px",
  fontWeight: 500,
}));
